import React from 'react';
import styles from './Categories.module.css';
import { TemplateCategoryEnum } from '@shared/Enums/TemplateCategoryEnum';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import TemplateCard from '@shared/Widgets/TemplateCard/TemplateCard';
import { TemplateCategoryEntity } from '@entities/TemplateCategory/Types';

interface CategoriesProps {
    category: TemplateCategoryEntity;
}

const Categories: React.FC<CategoriesProps> = ({ category }) => {
    return (
        <div className={styles.categories}>
            <div className={styles.categoryName}>
                <p>{category.category}</p>
            </div>
            <div className={styles.templatesCategory}>
                {category.templates &&
                Array.isArray(category.templates.data) ? (
                    category.templates.data.map((template, index) => (
                        <TemplateCard
                            template={template}
                            category={
                                category.category
                                    ? category.category
                                    : TemplateCategoryEnum.DIY
                            }
                            key={index}
                        />
                    ))
                ) : (
                    <div>No templates were found</div>
                )}
            </div>
        </div>
    );
};

export default Categories;
